var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkflowDesigner',{ref:"workflowDesigner"})
}
var staticRenderFns = []

export { render, staticRenderFns }